import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-30" }
const _hoisted_2 = { class: "sm:flex sm:flex-row sm:flex-nowrap" }
const _hoisted_3 = { class: "mb-20 sm:mb-0 sm:mt-7 sm:mr-30 sm:whitespace-nowrap sm:u-valign-inline-button" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", { class: "mb-30" }, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "mb-30"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FindPersonalOffer = _resolveComponent("FindPersonalOffer")!
  const _component_OffersThumbView = _resolveComponent("OffersThumbView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.labels.listHeading), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.labels.offerNumberTitleText), 1),
      _createElementVNode("div", null, [
        _createVNode(_component_FindPersonalOffer, { "details-url": _ctx.detailsUrl }, null, 8, ["details-url"])
      ])
    ]),
    _hoisted_4,
    _createVNode(_component_OffersThumbView, {
      model: _ctx.offers,
      "details-url": _ctx.detailsUrl
    }, null, 8, ["model", "details-url"]),
    (_ctx.offers.length < 1)
      ? (_openBlock(), _createElementBlock("h4", _hoisted_5, _toDisplayString(_ctx.maybePendingText), 1))
      : _createCommentVNode("", true)
  ]))
}